// extracted by mini-css-extract-plugin
export default {"hidden":"StickyFooter_hidden__SvmHG","slideDown":"StickyFooter_slideDown__4GPbE","visible":"StickyFooter_visible__d1C8D","slideUp":"StickyFooter_slideUp__OC6MB"};